// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: '25bc2cd7-2fd1-42a5-9180-e80212c67039',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9c491340-c23c-4a5d-a667-06f164ce8c77',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Activate_Shop_Bundle',
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: '6e01b332-828e-42b8-889c-fcdae05a3cce',
      type: 'Text',
      name: '',
      className: '',
      x: -328,
      y: 101,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Premium Pass',
      localize: true,
      maxWidth: 394,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1c2c7d',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039',
      data: {
        translations: {
          en_US: 'Premium Pass',
          it_IT: 'Pass Premium',
          fr_FR: 'Pass Premium',
          de_DE: 'Premium-Pass',
          es_ES: 'Pase Premium',
          pt_PT: 'Passe Premium',
          pl_PL: 'Przepustka Premium',
          nl_NL: 'Premiumpas',
          ko_KR: '프리미엄 패스',
          ja_JP: 'プレミアムパス'
        }
      }
    },
    {
      id: '3b1e7e5e-9e7e-42df-a44c-c8b016e86358',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: -332,
      y: 10,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Up to <seasonPass.rewardsAmount> additional rewards!',
      localize: true,
      maxWidth: 440,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#8f2c2b',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: '#8f2c2b',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039',
      data: {
        translations: {
          en_US: 'Up to <seasonPass.rewardsAmount> additional rewards!',
          it_IT: 'Fino a <seasonPass.rewardsAmount> ricompense aggiuntive!',
          fr_FR: 'Jusqu’à <seasonPass.rewardsAmount> récompenses supplémentaires !',
          de_DE: 'Bis zu <seasonPass.rewardsAmount> zusätzliche Belohnungen!',
          es_ES: '¡Hasta <seasonPass.rewardsAmount> recompensas adicionales!',
          pt_PT: 'Até <seasonPass.rewardsAmount> recompensas adicionais!',
          pl_PL: 'Do <seasonPass.rewardsAmount> dodatkowych nagród!',
          nl_NL: 'Tot <seasonPass.rewardsAmount> extra beloningen!',
          ko_KR: '<seasonPass.rewardsAmount>개의 추가 보상까지!',
          ja_JP: '<seasonPass.rewardsAmount>個の追加報酬！'
        }
      }
    },
    {
      id: 'fb0db410-7f89-49c3-a9d0-4d4dd7d5fb58',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: -246,
      y: -178,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: 'b0d06103-ce26-403f-856d-5d7ff50a172b',
      type: 'Container',
      name: 'buyButton',
      className: '',
      x: 220,
      y: 99,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: '14dd5a2a-729c-4944-aa9e-d3ddfaa841c3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 165,
      y: -106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Coins_Stack',
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: 'e3fc2560-0833-430a-9e60-2a9dc0ef595a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 276,
      y: -107,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Heart',
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: '51a3d35b-b682-4d4a-a76b-6aac8857a40d',
      type: 'Container',
      name: 'ticketContainer',
      className: '',
      x: 223,
      y: -7,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: '9f11bc37-4a65-476c-b427-4ded8eb04d15',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 276,
      y: -111,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<seasonPass.maxLives>',
      localize: false,
      maxWidth: 98,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#AC002F',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: 'd1e96022-7174-42b7-915f-e3424ee4eae8',
      type: 'Text',
      name: '',
      className: '',
      x: 276,
      y: -76,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Max',
      localize: true,
      maxWidth: 98,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1c2c7d',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1c2c7d',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: 'f936f6ae-e8a4-4dee-984c-703c50cb97e0',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 167,
      y: -76,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x<seasonPass.firstCoinReward>',
      localize: false,
      maxWidth: 98,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1c2c7d',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1c2c7d',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25bc2cd7-2fd1-42a5-9180-e80212c67039'
    },
    {
      id: 'bcfb1546-5cf2-48c2-9013-df690062b458',
      type: 'Sprite',
      name: 'timer',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: 'fb0db410-7f89-49c3-a9d0-4d4dd7d5fb58'
    },
    {
      id: '661deede-70e9-4e43-9421-240828a86ce4',
      type: 'Text',
      name: 'timerText',
      className: 'variable_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<seasonPass.endTime>',
      localize: false,
      maxWidth: 150,
      maxHeight: 40,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fb0db410-7f89-49c3-a9d0-4d4dd7d5fb58'
    },
    {
      id: 'd79d6add-a2a6-48fb-9026-5bb9e11f8f6a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -95,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: 'fb0db410-7f89-49c3-a9d0-4d4dd7d5fb58'
    },
    {
      id: '6f9ce01a-512d-428f-9b7f-ad587c68746e',
      type: 'Layout',
      name: 'nineSliceButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b0d06103-ce26-403f-856d-5d7ff50a172b',
      data: {
        color: 'green'
      }
    },
    {
      id: 'a6877a94-f410-4f41-a256-31ccb26ed27f',
      type: 'Text',
      name: 'priceLabelText',
      className: 'upperCase_SPL',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Activate',
      localize: true,
      maxWidth: 219,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#01632D',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b0d06103-ce26-403f-856d-5d7ff50a172b'
    },
    {
      id: 'fc84382c-0623-4f07-a220-9a2692ec2ff1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Ticket',
      parent: '51a3d35b-b682-4d4a-a76b-6aac8857a40d'
    },
    {
      id: 'ea46f396-8cca-4183-ac8e-f26a0c077c0b',
      type: 'Text',
      name: 'priceTxt',
      className: 'variable_SPL',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<seasonPass.price>',
      localize: false,
      maxWidth: 176,
      maxHeight: 64,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#7D2726',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '#FFFA77',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '51a3d35b-b682-4d4a-a76b-6aac8857a40d'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  handleResize: false
} as const;

export class SeasonPassShopOfferLayout {
  static raw = raw;
  root!: Container;
  timerContainer!: Container;
  buyButton!: Container;
  ticketContainer!: Container;
  timer!: Sprite;
  timerText!: Text;
  nineSliceButton!: ButtonLargeLayout & { data: typeof raw['list'][15]['data'] };
  priceLabelText!: Text;
  priceTxt!: Text;
  variable_SPL!: (Text & { data: typeof raw['list'][3]['data'] } | Text)[];
  upperCase_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
